import { FormControl } from '@angular/forms';
import { required } from '../../../../forms/form-control-options.constants';
import { BaseFormControls } from '../../../../forms/form-controls/base.form-controls';

export class GrocyDashboardProductFormControls extends BaseFormControls {
  barcode = new FormControl<string | null>(null);
  product = new FormControl<string | null>(null, required);
}
